/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sensitive_Info_TitleInputs */

const en_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sensitive information`)
};

const id_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informasi sensitif`)
};

const ms_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maklumat sensitif`)
};

const ca_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informació sensible.`)
};

const cs_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citlivé informace`)
};

const da_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Følsomme oplysninger`)
};

const de_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertrauliche Informationen`)
};

const et_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delikaatsed andmed`)
};

const es_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información sensible`)
};

const fr_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations sensibles`)
};

const hr_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osjetljive informacije.`)
};

const it_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni sensibili`)
};

const lv_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jutīga informācija.`)
};

const lt_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jautri informacija`)
};

const hu_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Érzékeny információ`)
};

const nl_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gevoelige informatie`)
};

const nb_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sensitive opplysninger`)
};

const pl_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrażliwe informacje`)
};

const pt_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações confidenciais`)
};

const ro_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informații sensibile`)
};

const sk_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citlivé informácie`)
};

const sl_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Občutljive informacije`)
};

const fi_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arkaluonteiset tiedot`)
};

const sv_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Känslig information`)
};

const vi_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin nhạy cảm`)
};

const tr_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hassas bilgiler`)
};

const el_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ευαίσθητες πληροφορίες`)
};

const bg_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чувствителна информация.`)
};

const ru_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конфиденциальная информация`)
};

const sr_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Осетљиве информације`)
};

const uk_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конфіденційна інформація`)
};

const ka_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`სენსიტიური ინფორმაცია.`)
};

const hi_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवेदनशील जानकारी`)
};

const th_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อมูลสำคัญ`)
};

const ko_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`민감한 정보`)
};

const zh_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敏感信息`)
};

const zh_tw_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敏感資訊`)
};

const ja_sensitive_info_title = /** @type {(inputs: Sensitive_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`機密情報`)
};

/**
* | output |
* | --- |
* | "Sensitive information" |
*
* @param {Sensitive_Info_TitleInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const sensitive_info_title = /** @type {((inputs?: Sensitive_Info_TitleInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sensitive_Info_TitleInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sensitive_info_title(inputs)
	if (locale === "ms") return ms_sensitive_info_title(inputs)
	if (locale === "ca") return ca_sensitive_info_title(inputs)
	if (locale === "cs") return cs_sensitive_info_title(inputs)
	if (locale === "da") return da_sensitive_info_title(inputs)
	if (locale === "de") return de_sensitive_info_title(inputs)
	if (locale === "et") return et_sensitive_info_title(inputs)
	if (locale === "es") return es_sensitive_info_title(inputs)
	if (locale === "fr") return fr_sensitive_info_title(inputs)
	if (locale === "hr") return hr_sensitive_info_title(inputs)
	if (locale === "it") return it_sensitive_info_title(inputs)
	if (locale === "lv") return lv_sensitive_info_title(inputs)
	if (locale === "lt") return lt_sensitive_info_title(inputs)
	if (locale === "hu") return hu_sensitive_info_title(inputs)
	if (locale === "nl") return nl_sensitive_info_title(inputs)
	if (locale === "nb") return nb_sensitive_info_title(inputs)
	if (locale === "pl") return pl_sensitive_info_title(inputs)
	if (locale === "pt") return pt_sensitive_info_title(inputs)
	if (locale === "ro") return ro_sensitive_info_title(inputs)
	if (locale === "sk") return sk_sensitive_info_title(inputs)
	if (locale === "sl") return sl_sensitive_info_title(inputs)
	if (locale === "fi") return fi_sensitive_info_title(inputs)
	if (locale === "sv") return sv_sensitive_info_title(inputs)
	if (locale === "vi") return vi_sensitive_info_title(inputs)
	if (locale === "tr") return tr_sensitive_info_title(inputs)
	if (locale === "el") return el_sensitive_info_title(inputs)
	if (locale === "bg") return bg_sensitive_info_title(inputs)
	if (locale === "ru") return ru_sensitive_info_title(inputs)
	if (locale === "sr") return sr_sensitive_info_title(inputs)
	if (locale === "uk") return uk_sensitive_info_title(inputs)
	if (locale === "ka") return ka_sensitive_info_title(inputs)
	if (locale === "hi") return hi_sensitive_info_title(inputs)
	if (locale === "th") return th_sensitive_info_title(inputs)
	if (locale === "ko") return ko_sensitive_info_title(inputs)
	if (locale === "zh") return zh_sensitive_info_title(inputs)
	if (locale === "zh-tw") return zh_tw_sensitive_info_title(inputs)
	if (locale === "ja") return ja_sensitive_info_title(inputs)
	return en_sensitive_info_title(inputs)
});